import type { PropsWithChildren } from 'react';

export const SubTitle: React.FC<PropsWithChildren> = ({ children }) => (
    <p className="text-sm text-midnight pt-2 text-center">{children}</p>
);
